const isMobilePlansView = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(max-width: 767px)")?.matches ||
    window.innerWidth <= 767);

const PlanDetailsView = () =>
  isMobilePlansView()
    ? import(
        /*webpackChunkName: "PlanDetailsLoggedMobileView"*/ "../../../views/sales/PlanDetailsViewMobile.vue"
      )
    : import(
        /*webpackChunkName: "PlanDetailsLoggedView"*/ "../../../views/sales/PlanDetailsView.vue"
      );
export default {
  path: "plans-logged",
  name: "plans-logged",
  component: PlanDetailsView,
  meta: {
    requiresAuth: true,
    requiresEntitlement: false,
    hideMenuOptions: true,
  },
};
